import * as React from 'react';
import { Button } from '@cian/ui-kit';

interface ICallbackButtonProps {
  onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
}

export const CallbackButton: React.FC<ICallbackButtonProps> = ({ onClick }) => {
  return (
    <div data-mark="CallMeBackButton">
      <Button onClick={onClick} size="M" theme="fill_secondary" type="button" fullWidth>
        Перезвоните мне
      </Button>
    </div>
  );
};
